import { useEffect } from 'react';
import ContentManager from 'src/componentes/content-manager';
import ComentarioIcon from 'src/paginas/comentario/comentariosIcon';
import ComentarioModal from './ComentarioModal';

const defaultEndpoints = {
  obter: '/Comentario/ObterComentarios',
  salvar: '/Comentario/SalvarComentario',
  excluir: '/Comentario/ExcluirComentario',
  curtir: '/Comentario/CurtirComentario',
  responder: '/Comentario/ResponderComentario',
  obterRespostas: '/Comentario/ObterRespostas',
};

export const openComentarioModal = ({
  tipoEntidade,
  // se ninguém informar outro id, fico com id original do item
  entidadeId,
  quantidadeComentarios = 0,
  dialogTitle,
  dialogConfig,
  endpoints,
  onChangeQuantidade,
  modalProps = {},
  item,
}) => {
  if (!tipoEntidade || entidadeId == null) return;

  ContentManager.addContent(
    <ComentarioModal
      config={{
        tipoEntidade,
        entidadeId,
        endpoints: { ...defaultEndpoints, ...endpoints },
      }}
      quantidadeComentarios={quantidadeComentarios}
      onChangeQuantidade={onChangeQuantidade}
      dialogConfig={
        dialogTitle
          ? { ...(dialogConfig || {}), title: dialogTitle }
          : dialogConfig
      }
      item={item}
      dataInicio={modalProps?.dataInicio || null}
      dataTermino={modalProps?.dataTermino || null}
      {...modalProps}
    />
  );
};

const modaisAbertos = new Set();

const ComentarioButton = ({
  item,
  tipoEntidade,
  entidadeId,
  onCountChange,
  dialogTitle,
  dialogConfig,
  endpoints,
  entidadeIdOpenModal,
  modalProps = {},
  disabled = false,
  noMargin = false,
}) => {
  const count =
    item?.quantidadeComentarios != null ? item.quantidadeComentarios : 0;

  const finalEntidadeId = entidadeId ?? item?.id;
  const chaveModal = `${tipoEntidade}-${finalEntidadeId}`;

  const handleClick = () => {
    if (disabled) return;

    openComentarioModal({
      tipoEntidade,
      entidadeId: finalEntidadeId,
      quantidadeComentarios: count,
      dialogTitle,
      dialogConfig,
      endpoints,
      onChangeQuantidade: (newCount) => {
        if (item) {
          item.quantidadeComentarios = newCount;
        }
        if (onCountChange) {
          onCountChange(item, newCount);
        }
      },
      item,
      modalProps,
    });
  };

  useEffect(() => {
    const shouldOpen =
      entidadeIdOpenModal != null &&
      Number(entidadeIdOpenModal) === finalEntidadeId &&
      !modaisAbertos.has(chaveModal);

    if (shouldOpen) {
      modaisAbertos.add(chaveModal);
      handleClick();
    }
  }, []);

  return (
    <ComentarioIcon
      handleComentariosClick={handleClick}
      valor={{ quantidadeComentarios: count }}
      disabled={disabled}
      noMargin={noMargin}
    />
  );
};

export default ComentarioButton;
